import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';

import { I18nProvider } from './i18n/I18nProvider';
import { Header } from './components/Header';
import { Footer } from './components/Footer';

import HomePage from './pages/HomePage';
import HeritagePage from './pages/HeritagePage';
import CollectionsPage from './pages/CollectionsPage';
import BoutiquePage from './pages/BoutiquePage';
import B2BPage from './pages/B2BPage';
import ContactPage from './pages/ContactPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" />
          <Routes>
            <Route path="/" element={<PublicShell><HomePage /></PublicShell>} />
            <Route path="/heritage" element={<PublicShell><HeritagePage /></PublicShell>} />
            <Route path="/collections" element={<PublicShell><CollectionsPage /></PublicShell>} />
            <Route path="/boutique" element={<PublicShell><BoutiquePage /></PublicShell>} />
            <Route path="/b2b" element={<PublicShell><B2BPage /></PublicShell>} />
            <Route path="/contact" element={<PublicShell><ContactPage /></PublicShell>} />
            <Route path="/mentions-legales" element={<PublicShell><MentionsLegalesPage /></PublicShell>} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}

export default App;
